import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonGroup as HeroButtonGroup } from '@heroui/react';
import { Button } from '../Button/Button';
export const ButtonGroup = ({ children, options, value, onChange, multiple = false, selectedColor = 'primary', unselectedColor = 'default', underlined = false, error, className, ...heroProps }) => {
    if (children) {
        return (_jsxs("div", { className: "space-y-1", children: [_jsx(HeroButtonGroup, { ...heroProps, className: className, children: children }), error && (_jsx("div", { className: "text-sm text-error", role: "alert", children: error }))] }));
    }
    if (!options || !onChange) {
        throw new Error('ButtonGroup: When not using children, options and onChange are required');
    }
    const handleOptionClick = (optionValue) => {
        if (heroProps.isDisabled)
            return;
        if (multiple) {
            const currentValue = Array.isArray(value) ? value : [];
            const newValue = currentValue.includes(optionValue)
                ? currentValue.filter(v => v !== optionValue)
                : [...currentValue, optionValue];
            onChange(newValue);
        }
        else {
            onChange(optionValue === value ? null : optionValue);
        }
    };
    const isSelected = (optionValue) => {
        if (multiple) {
            return Array.isArray(value) && value.includes(optionValue);
        }
        return value === optionValue;
    };
    return (_jsxs("div", { className: "space-y-1", children: [_jsx(HeroButtonGroup, { ...heroProps, className: className, children: options.map((option) => {
                    const IconComponent = option.icon;
                    const selected = isSelected(option.value);
                    return (_jsx(Button, { onPress: () => handleOptionClick(option.value), isDisabled: option.disabled || heroProps.isDisabled, color: selected ? selectedColor : unselectedColor, variant: underlined ? 'light' : undefined, className: underlined && selected ? 'border-b-2 border-primary rounded-b-none' : '', children: _jsxs("div", { className: "flex items-center gap-2", children: [IconComponent && _jsx(IconComponent, { className: "w-4 h-4" }), typeof option.label === 'string' ? _jsx("span", { children: option.label }) : option.label] }) }, option.value));
                }) }), error && (_jsx("div", { className: "text-sm text-error", role: "alert", children: error }))] }));
};
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map